import { GetStaticProps, NextPage } from 'next'
import styled from '@emotion/styled'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  text-align: center;
  padding: 0 20px;
`

const Title = styled.h1`
  font-size: 72px;
  color: #333;
`

const Subtitle = styled.h2`
  font-size: 32px;
  color: #666;
`

const Message = styled.p`
  font-size: 20px;
  color: #999;
`

const GoBackButton = styled.button`
  margin-top: 20px;
  font-size: 18px;
  color: #0070f3;
  background: none;
  border: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`

const Classy404: NextPage = () => {
  const { t } = useTranslation('common') // Use the 'common' namespace

  return (
    <Container>
      <Title>{t('404.title')}</Title>
      <Subtitle>{t('404.subtitle')}</Subtitle>
      <Message>{t('404.message')}</Message>
      <GoBackButton onClick={goBack}>{t('404.goBack')}</GoBackButton>
    </Container>
  )
}

const goBack = () => {
  if (window.location.pathname == '/invalid_params') {
    window.history.go(-2)
  }

  window.history.back()
}

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale || 'en', ['common'])), // Load the 'common' namespace
  },
})

export default Classy404
